<template>
  <div ref="container">
    <div class="coupon-list" v-if="couponsList.length > 0">
      <h1>免费专区</h1>
      <div
        class="item acea-row row-center-wrapper"
        v-for="(item, index) in couponsList"
        :key="index"
      >
        <div class="money" :class="item.is_use ? 'moneyGray' : ''">
          ￥<span class="num">{{ item.coupon_price }}</span>
        </div>
        <div class="text">
          <div class="condition line1">
            {{ item.title }}
          </div>
          <div class="condition line1" style="color:#999;font-size: .26rem">
            购物满{{ item.use_min_price }}元可用
          </div>
          <div class="data acea-row row-between-wrapper" style="height: 29px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;width: 200px;">
            {{ item.store_name ? "仅限" + item.store_name : "全部" }}
          </div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="item.end_time !== 0">
              {{ item.start_time ? item.start_time + "-" : ""
              }}{{ item.end_time }}
            </div>
            <div v-else>不限时</div>
            <div class="bnt gray" v-if="item.is_use === true">已领取</div>
            <div class="bnt gray" v-else-if="item.is_use === 2">已领完</div>
            <div
              class="bnt bg-color-red"
              v-else
              @click="getCoupon(item.id, index)"
            >
              立即领取
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="coupon-list" v-if="couponsListTwo.length > 0">
      <h1>活动专区</h1>
      <div
        class="item acea-row row-center-wrapper"
        v-for="(item, index) in couponsListTwo"
        :key="index"
      >
        <div class="money">
          ￥<span class="num">{{ item.coupon_price }}</span>
        </div>
        <div class="text">
          <div class="condition line1">
            {{ item.title }}
          </div>
          <div class="condition line1" v-if="item.use_min_price > 0" style="color:#999;font-size: .26rem">
            购物满{{ item.use_min_price }}元可用
          </div>
          <div class="condition line1" v-if="item.use_min_price == 0" style="color:#999;font-size: .26rem">
            无门槛购物抵用
          </div>
          <div class="data acea-row row-between-wrapper" style="height: 29px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;width: 200px;">
            {{ item.store_name ? "仅限" + item.store_name : "全部" }}
          </div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="item.end_time !== 0">
              {{ item.start_time ? item.start_time + "-" : ""
              }}{{ item.end_time }}
            </div>
            <div v-else>不限时</div>
            <div class="bnt bg-color-red" @click="buyCoupon(item.id, index)">
              ￥{{item.price}} 购买
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--暂无优惠券-->
    <div
      class="noCommodity"
      v-cloak
      v-if="couponsList.length === 0 && page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>
  </div>
</template>
<script>
import {isWeixin} from "@utils";
import { pay } from "@libs/wechat";
import { Toast } from 'vant';
import { getCoupon, getCouponReceive, buyCouponYsf, buyCouponWechat, getOrderStatus } from "@api/user";
export default {
  name: "getCoupon",
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 10,
      couponsList: [],
      couponsListTwo: [],
      pay_type: isWeixin() ? 'weixin' : 'ysf'
    };
  },
  mounted: function() {
    this.getUseCoupons();
  },
  methods: {
    getCoupon: function(id, index) {
      let that = this;
      let list = that.couponsList;
      getCouponReceive(id)
        .then(function() {
          list[index].is_use = true;
          that.$dialog.toast({ mes: "领取成功" });
        })
        .catch(function(res) {
          that.$dialog.toast({ mes: res.msg });
        });
    },
    buyCoupon: function(id, index) {
      let that = this;
      let list = that.couponsListTwo;
      if ('ysf' == that.pay_type) {
        buyCouponYsf({ couponId: list[index].id, pay_type: that.pay_type })
            .then(res => {
                upsdk.pluginReady(function() {
                  upsdk.pay({
                    tn: res.data.transNo,
                    success: function() {
                      let num = 0;
                      const interval = setInterval(() => {
                        if (num < 100) {
                          getOrderStatus({
                            orderId: res.data.orderId
                          }).then(response => {
                            num++;
                            if (response.data.result === 1) {
                              Toast("支付成功");
                              clearInterval(interval);
                            }
                          });
                        } else {
                          clearInterval(interval);
                        }
                      }, 500);
                    },
                    fail: function(err) {
                      console.log(err);
                      Toast("取消支付");
                    }
                  });
                });
            })
            .catch(res => {
              Toast(res.msg);
            });
      } else {
        buyCouponWechat({ couponId: list[index].id, pay_type: that.pay_type })
            .then(res => {
                var data = res.data;
                pay(data.data)
                    .finally(() => {
                      Toast("支付成功");
                    })
                    .catch(function() {
                      Toast("支付失败");
                    });
            })
            .catch(res => {
              Toast(res.msg);
            });
      }

    },
    getUseCoupons: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      getCoupon().then(res => {
        that.loading = false;
        that.couponsList = res.data.free;
        that.couponsListTwo = res.data.pay;
      });
    }
  }
};
</script>
